// What follows the account. The server owns it and this device only displays it; the pick of mage, realm and storm
// tier is the only part still written from here. Pure, so node tests can load it.
import type { GearState } from './gear.ts';

export interface Progress {
  gold: number;
  shop: Record<string, number>;
  cleared: number;
  best: Record<string, number>;
  kills: number;
  mainXp: number; // main-level xp
  gear: GearState;
  mastery: Record<string, number>; // per-mage xp
  bestiary: Record<string, number>;
  bounties: Record<string, number>;
  evolutions: Record<string, boolean>;
}

export interface Prefs {
  character: string;
  stage: number;
  stormTier: number;
}

export function prefsOf(save: Prefs): Prefs {
  return { character: save.character, stage: save.stage, stormTier: save.stormTier };
}
